import { createSelector } from 'reselect';

import { selectCartItems } from './selectCartItems';

export const selectActiveCartItems = createSelector(
    [selectCartItems],
    (items) => items.filter(item => item.quantity > 0 && item.isAvailable),
);
